import { SelectItem } from '../../types/ui';

export const getItemByKey = <T>(key: T, options: SelectItem<T>[]): SelectItem<T> => options?.find(x => x.value === key);
